import React from "react";

export const TwitterIcon = () => {
  return (
    <svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.03957 0.55957C2.56533 0.55957 0.55957 2.56533 0.55957 5.03957V22.9596C0.55957 25.4338 2.56533 27.4396 5.03957 27.4396H22.9596C25.4338 27.4396 27.4396 25.4338 27.4396 22.9596V5.03957C27.4396 2.56533 25.4338 0.55957 22.9596 0.55957H5.03957ZM6.37457 6.31957H11.4546L15.0621 11.4458L19.4396 6.31957H21.0396L15.7846 12.4721L22.2646 21.6796H17.1858L12.9996 15.7321L7.91957 21.6796H6.31957L12.2771 14.7058L6.37457 6.31957ZM8.82457 7.59957L17.8533 20.3996H19.8146L10.7858 7.59957H8.82457Z"
        fill="#686677"
      />
    </svg>
  );
};
